import Vue from 'vue'
import axios from 'axios'
import { API_BASE_URL } from '@/utils/urls'

function normalizeBaseUrl(url) {
  if (!url) return url
  return `${String(url).replace(/\/+$/, '')}/`
}

const axiosIns = axios.create({
  baseURL: normalizeBaseUrl(API_BASE_URL),
  withCredentials: true,
})

axiosIns.interceptors.request.use(
  async config => {
    const headers = {
      ...(config.headers || {}),
      Authorization: `Bearer ${localStorage.getItem('DuttonAuthToken')}`,
    }
    return { ...config, headers }
  },
  error => Promise.reject(error),
)

Vue.prototype.$http = axiosIns
export default axiosIns
